<template lang="pug">
  y-dialog(v-model="showDialog" fullscreen max-width="600" persistent scrollable content-class="round-3xl")
    v-card(min-height="90vh")
      v-card-title.pa-0
        div(style="width: 100%")
          div.pt-3(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
            div.main-container
              v-tabs(v-model="addApptTab" color="basic700" :height="50" fixed-tabs slider-size="5")
                v-tab.text-md.font-semibold.text-capitalize.px-0(style="justify-content: start; opacity: 1; max-width: unset;" disabled)
                  v-icon.mr-2(v-if="addApptTab > 0" color="success500" size="18") $yzi-check-circle
                  | 1. Patient
                v-tab.text-md.font-semibold.text-capitalize.px-0(style="justify-content: start; opacity: 1; max-width: unset;" disabled)
                  v-icon.mr-2(v-if="addApptTab > 1" color="success500" size="18") $yzi-check-circle
                  | 2. Set appointments
                v-tab.text-md.font-semibold.text-capitalize.px-0(style="justify-content: start; opacity: 1; max-width: unset;" disabled) 3. {{ $t('payment') }}
              div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

      v-card-text.px-0.pb-8
        v-tabs-items(v-model="addApptTab" touchless style="overflow: unset")
          v-tab-item
            v-container(style="max-width: 600px;")
              div(v-if="isHq")
                div.text-sm.font-semibold.neutral500--text.mt-4.mb-2 Branch
                company-dropdown-single-select
              appointment-patient.mt-6(v-if="!isHq || isHqAndHasCompanySelected" ref="patient" :prefill="patient")
                template(#title)
                  div.text-md.font-semibold.neutral700--text {{ $t('type_patient_identification') }}
          v-tab-item
            advance-appointment-details.mt-6(:key="advAppDetailsKey" ref="details" :show-form.sync="showForm" :selectedAppointment="selectedAppointment")
          v-tab-item
            v-container(style="max-width: 600px;")
              advance-appointment-payment.mt-6.px-8(ref="payment")

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-btn.button-md.neutral700--text.px-0(v-if="addApptTab === 0" @click="closeDialog" text) {{ $t('cancel') }}
        v-btn.button-md.neutral700--text.px-0(v-if="showBackButton" @click="goBack" text) {{ $t('back') }}
        v-spacer
        template(v-if="addApptTab < 2")
          v-btn.button-md(v-if="showSaveButton" :loading="isLoading" color="neutral700" depressed dark @click="saveAppointment") {{ $t('save') }}
          v-btn.button-md(v-else :loading="isLoading" color="neutral700" depressed :dark="!disabledNext" :disabled="disabledNext" @click="goNext") {{ $t('next') }}
        v-btn.button-md(v-else :loading="isLoading" color="neutral700" depressed dark @click="savePayment") {{ appointment.payment && appointment.payment.leadproducts && appointment.payment.leadproducts.length ? $t('save') : $t('finish') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AppointmentPatient from '@/components/clinic/appointment/AppointmentPatient.vue'
import AdvanceAppointmentDetails from '@/components/clinic/appointment/advance/AdvanceAppointmentDetails.vue'
import AdvanceAppointmentPayment from '@/components/clinic/appointment/advance/AdvanceAppointmentPayment.vue'
import CompanyDropdownSingleSelect from "@/components/hq/custom/CompanyDropdownSingleSelect.vue";

export default {
  components: {CompanyDropdownSingleSelect, AppointmentPatient, AdvanceAppointmentDetails, AdvanceAppointmentPayment },
  props: ['open', 'patient', 'selectedAppointment'],
  data () {
    return {
      isLoading: false,
      showForm: false,
      addApptTab: 0,
      advAppDetailsKey: 0
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      appointment: 'clinic/getTempAppointment',
      appointmentDetails: 'clinic/getTempAppointmentDetails',
      clinic: 'clinic/getClinic',
      isHq: 'hq/getIsHq',
      hqSelectedCompany: 'hq/getSelectedCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    disabledNext () {
      if (this.addApptTab === 0) {
        if (this.appointment) {
          if (!this.appointment.patient) {
            return true
          } else {
            if (this.defaultIC && !this.appointment.patient.ic) {
              return true
            }
            if (!this.defaultIC && !this.appointment.patient.phone) {
              return true
            }
          }
        }
      }
      return false
    },
    showSaveButton () {
      let show = false
      if (this.addApptTab === 1) {
        if (this.showForm) { show = true }
        if (!(this.appointment && this.appointment.appointments && this.appointment.appointments.length)) { show = true }
      }
      return show
    },
    showBackButton () {
      let show = false
      if (this.addApptTab > 0) { show = true }
      if (this.addApptTab === 1 && (this.appointment && this.appointment.appointments && this.appointment.appointments.length)) { show = false }
      return show
    },
    defaultIC () {
      if (this.clinic && this.clinic.customer_uid_type === 'ic') {
        return true
      }
      return false
    },
    isHqAndHasCompanySelected() {
      return this.isHq && this.hqSelectedCompany !== null
    }
  },
  mounted () {
    if (this.patient) {
      this.addApptTab = 1
    }
  },
  watch: {
    hqSelectedCompany(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== null) {
        this.advAppDetailsKey++
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    goNext () {
      if (this.addApptTab === 0) {
        if (!this.$refs.patient.$refs.form.validate()) {
          let message = this.$t('error_message.please_fill_out_all_required')
          this.showMessage(['error', message])
          return
        }
        if (!this.appointment.patient) {
          let message = 'Please select patient'
          this.showMessage(['error', message])
          return
        }
        this.checkPatient()
      } else if (this.addApptTab === 1) {
        this.addApptTab = 2
      }
    },
    saveAppointment () {
      if (!this.$refs.details.$refs.forms.$refs.form.validate()) {
        let message = this.$t('error_message.please_fill_out_all_required')
        this.showMessage(['error', message])
        return
      }
      if (!this.appointment || !this.appointment.patient || !this.appointment.patient.id) {
        let message = 'No patient detected. Please select a patient again.'
        this.showMessage(['error', message])
        return
      }
      if (this.appointmentDetails.sessions && !this.appointmentDetails.frequency) {
        if (this.appointmentDetails.sessions.filter(f => f.start).length && this.appointmentDetails.sessions.filter(f => f.preset_date).length) {
          let message = 'Please finalize your time selections.'
          this.showMessage(['error', message])
          return
        }
      }
      this.isLoading = true
      let payload = {
        patient: this.appointment.patient.id,
        remarks: this.appointmentDetails.remarks,
        sessions: this.appointmentDetails.sessions.map(m => { return { ...m, provider: m.provider.id, services: m.services.map(m => m.id) } })
      }
      if (this.appointmentDetails.frequency) {
        payload.type = 'recur'
        payload.repeat = this.appointmentDetails.frequency
        if (this.appointmentDetails.frequency !== 'custom') {
          payload.recurrences = this.appointmentDetails.recurring_data.recurrences
        }
      } else if (this.appointmentDetails.services_providers.length > 1) {
        payload.type = 'combo'
        payload.repeat = 'one-time'
      }
      if (this.appointment.serial_no) {
        payload.serial_no = this.appointment.serial_no
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      const endpoint = `/clinics/${companySlug}/appointments/series`
      this.$axios.post(endpoint, payload)
        .then(resp => {
          let appts = []
          if (this.appointment.appointments) {
            appts = [ ...this.appointment.appointments ]
          }
          appts.push(resp.data)
          let respPayload = {
            appointments: appts
          }
          if (!this.appointment.serial_no) {
            respPayload.serial_no = resp.data.serial_no
          }
          this.$store.commit('clinic/updateTempAppointment', respPayload)
          this.$store.commit('clinic/resetTempAppointmentDetails')
          this.updateActivityLog(endpoint, payload, resp, 'POST', resp.id, 'Add new appointment')
          this.showForm = false
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    savePatient (id) {
      this.isLoading = true
      let data = { 
      ...this.appointment.patient,
        source: 'admin'
      }
      if (!this.checkEmptyAddress(this.appointment.address)) {
        data.address = this.appointment.address
      }
      if (id) {
        const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
        const endpoint = `/clinics/${companySlug}/patients/${id}`
        this.$axios.patch(endpoint, data)
          .then(resp => {
            data = {
              patient: resp.data,
              new_patient: resp.data.id
            }
            this.$store.commit('clinic/updateTempAppointment', data)
            this.addApptTab = 1
            this.updateActivityLog(endpoint, data, resp, 'PATCH', resp.id, 'Add new patient')
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
        this.$axios.post(`/clinics/${companySlug}/patients`, data)
          .then(resp => {
            data = {
              patient: resp.data,
              new_patient: resp.data.id
            }
            this.$store.commit('clinic/updateTempAppointment', data)
            this.addApptTab = 1
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    savePayment () {
      if (!this.$refs.payment.$refs.form.validate()) {
        return
      }
      if (!this.appointment.payment || !this.appointment.payment.leadproducts || !this.appointment.payment.leadproducts.length) {
        this.closeResetDialog()
        return
      }
      this.isLoading = true
      let paymentPayload = {
        leadproducts: this.appointment.payment.leadproducts,
        payment_method: this.appointment.payment.payment_method,
        internal_description: this.appointment.payment.internal_description,
      }
      const companySlug = this.isHq ? this.hqSelectedCompany.slug : this.company.slug
      const endpoint = `/clinics/${companySlug}/appointments/payments`
      this.$axios.post(endpoint, paymentPayload)
        .then(resp => {
          this.updateActivityLog(endpoint, paymentPayload, resp, 'POST', resp.id, 'Record payment appointment')
          this.closeResetDialog()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
        })
        .finally(() => {
          this.isLoading = true
        })
    },
    checkPatient () {
      if (this.appointment.patient.id) {
        this.addApptTab = 1
        return
      }
       if (this.appointment.new_patient) {
        this.savePatient(this.appointment.new_patient)
      } else {
        this.savePatient()
      }
    },
    closeResetDialog () {
      this.showDialog = false
      this.$emit('reset')
    },
    closeDialog () {
      if (this.appointment.reset) {
        this.closeResetDialog()
        return
      }
      this.showDialog = false
      this.$emit('closed')
    },
    goBack () {
      this.addApptTab--
    },
    checkEmptyAddress (address) {
      if (!address) {
        return true
      }
      if (Object.keys(address).length === 0) {
        return true
      } else if (Object.values(address).every(val => !val)) {
        return true
      }
      return false
    },
    updateActivityLog (endpoint, payload, response, method, id, activity) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'appointment',
        activity: activity,
        raw_data: { endpoint, payload, response: response.data, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    }
  },
  destroyed () {
    this.$store.commit('clinic/resetTempAppointment')
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height: 5px;
  top: 45px;
  left: 0px;
  right: 0px;
}
</style>